
// @ts-nocheck
import locale_de_46json_5e288007 from "#nuxt-i18n/5e288007";
import locale_en_46json_4b94a34e from "#nuxt-i18n/4b94a34e";
import locale_fr_46json_ada4134e from "#nuxt-i18n/ada4134e";

export const localeCodes =  [
  "de",
  "en",
  "fr"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_5e288007",
      load: () => Promise.resolve(locale_de_46json_5e288007),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_4b94a34e",
      load: () => Promise.resolve(locale_en_46json_4b94a34e),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ada4134e",
      load: () => Promise.resolve(locale_fr_46json_ada4134e),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      language: "de-DE",
      code: "de",
      name: "Deutsch",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      language: "en-US",
      code: "en",
      name: "English",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      language: "fr-FR",
      code: "fr",
      name: "Française",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    language: "de-DE",
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    language: "en-US",
    code: "en",
    name: "English",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    language: "fr-FR",
    code: "fr",
    name: "Française",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/